import script from "./CRM20_005RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM20_005RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM20_005RPT.vue?vue&type=style&index=0&id=a10c9646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a10c9646"]])

export default __exports__